"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var escape_1 = __importDefault(require("lodash/escape"));

var slugify_1 = __importDefault(require("slugify"));

function safeSlugify(text) {
  return "h-".concat(escape_1.default(slugify_1.default(text, {
    remove: /[!"#$%&'\.()*+,\/:;<=>?@\[\]\\^_`{|}~]/g,
    lower: true
  })));
}

function headingToSlug(node) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var slugified = safeSlugify(node.textContent);
  if (index === 0) return slugified;
  return "".concat(slugified, "-").concat(index);
}

exports.default = headingToSlug;